import {AuthRequestInfoVo} from '../../common/shared/api/nicolas/vo/AuthRequstInfoVo.interface';
import {AuthRequestInfo} from '../generated/types';

export function createAuthRequestInfo(
  authRequestInfoVo: AuthRequestInfoVo
): AuthRequestInfo {
  return {
    authUrl: authRequestInfoVo.auth_url,
  };
}
